'use client';

import { useId } from 'react';
import { Gradient } from '../gradient';

export const Protection = () => {
  const gradientId = useId();

  return (
    <>
      <Gradient gradientId={gradientId} />
      <svg viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_3451_22437)">
          <path
            d="M325 115.27C325 115.27 314.742 266.479 200.033 325C85.2585 266.453 75 115.27 75 115.27C147.775 115.27 200.033 75 200.033 75C200.033 75 252.225 115.27 325 115.27Z"
            fill="white"
          />
        </g>
        <path
          d="M314.544 122.356C314.544 122.356 305.152 260.912 200.036 314.578C94.8535 260.912 85.4609 122.356 85.4609 122.356C152.074 122.356 200.036 85.4292 200.036 85.4292C200.036 85.4292 247.864 122.356 314.544 122.356Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.25"
          d="M84.9955 122.355C84.9955 122.355 94.388 260.91 199.504 314.55V85.4541C199.504 85.4541 151.675 122.355 84.9955 122.355Z"
          fill="white"
        />
        <g filter="url(#filter1_d_3451_22437)">
          <path
            d="M98.8703 170.273C98.9314 170.76 99.0348 171.266 99.1787 171.782C99.4237 172.782 99.7307 174.25 100.269 176.171C101.723 181.599 103.46 187.088 105.467 192.592C112.065 210.846 121.303 228.957 132.467 245.526C143.63 262.095 156.421 276.68 169.853 288.155C173.896 291.629 177.981 294.781 182.072 297.586C183.518 298.611 184.637 299.258 185.405 299.761C185.794 300.033 186.182 300.253 186.563 300.417C186.18 300.072 185.79 299.772 185.401 299.522C184.622 298.921 183.522 298.222 182.082 297.14C178.022 294.176 173.976 290.925 169.968 287.409C156.704 275.852 144.09 261.348 133.04 244.95C121.99 228.551 112.782 210.667 106.082 192.596C104.035 187.133 102.214 181.676 100.628 176.259C100.034 174.328 99.6719 172.85 99.3627 171.834C99.2384 171.321 99.0733 170.797 98.8703 170.273Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3451_22437"
            x="69"
            y="71"
            width="262"
            height="262"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22437"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22437"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_3451_22437"
            x="92.8711"
            y="166.273"
            width="99.6914"
            height="142.144"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22437"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22437"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
